<form [formGroup]="form" novalidate >
    <div class="form-section-body">
      <div class="form-block block-plan-rules">
        <div class="block-content">
          <div class="form-row row-checkbox border noborder-important">
            <mat-checkbox  formControlName="usageBased" (change)="onChange($event)"  disableRipple="true" color="primary" class="custom-mat-checkbox checkbox-simple-line rounded" >
            <span class="typo semi-condensed fw400">Yes, I would like to make this charge "Usage Based"</span>
          </mat-checkbox>
          </div>
        </div>
        <div [@onRowStatusChange]="(form.get('usageBased')?.value ? _visibleState.isVisible : _visibleState.isHidden)">
          <div class="block-content subdivision">
              <p class="s-title">Select the consumption method to be used for this charge:</p>
              <mat-radio-group formControlName="usageType" aria-label="Select an option">
              <div class="radio-select-item">
              <!-- <mat-checkbox  formControlName="aggregated"  disableRipple="true" color="primary" class="custom-mat-checkbox checkbox-simple-line rounded" >
                  <span class="typo semi-condensed fw400">Aggregated - Sum total of all records inserted within the billing period</span>
                </mat-checkbox> -->
                <mat-radio-button value="aggregated">Aggregated - Sum total of all records inserted within the billing period</mat-radio-button>
              </div>  
              <div class="radio-select-item">
                <!-- <mat-checkbox  formControlName="lastRecord"  disableRipple="true" color="primary" class="custom-mat-checkbox checkbox-simple-line rounded" >
                  <span class="typo semi-condensed fw400">Last Record - Use only last record inserted within the billing period</span>
                </mat-checkbox> -->
                <mat-radio-button value="lastRecord">Last Record - Use only last record inserted within the billing period</mat-radio-button>
    
              </div>
                </mat-radio-group>
          </div>
        </div>
      </div>
    </div>
  </form>
  